<script>
    import TwinklingStar from "./Elements/TwinklingStar.svelte";
    import {onDestroy, onMount} from "svelte";
    import spinShrink from "../animation-configs/spinShrink";
    import {labels, mainTimeline} from "../timelines/main-timeline";
    import gsap from "gsap";

    const startPosition = {x: 800, y: 450};
    const endMin = 400;
    const endMax = 600;
    const stars = Array.from(new Array(85));

    const timeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    let allStars;

    const {planetsStart, planetsEnd} = labels;

    function randomBetweenMinusOneAndOne() {
      return Math.random() * 2 - 1;
    }

    function randomlyNegative(num) {
      return Math.random() > 0.5 ? num : num * -1
    }

    function randoPosition() {
      const distance = randomlyNegative(Math.random() * endMax + endMin);

      const proportionX = Math.random();
      const proportionY = 1 - proportionX;

      const distanceX = distance * proportionX;
      const distanceY = distance * proportionY;
      const x = randomlyNegative(distanceX) + startPosition.x;
      const y = randomlyNegative(distanceY) + startPosition.y;

      return `translate(${x} ${y})`
    }

    onMount(() => {

        const stars = Array.from(allStars.getElementsByClassName('star'));

        timeline
            .from(stars, {
                x: startPosition.x / 2,
                y: startPosition.y / 2,
                opacity: 0,
                scale: 0,
                duration: 1,
                stagger: 0.005,
            })

            outTimeline
                .to(allStars, spinShrink(1));

        mainTimeline.add(timeline, planetsStart);
        mainTimeline.add(outTimeline, planetsEnd);
    });

    onDestroy(() => {
       timeline.clear();
    });

</script>

<g class="all-stars" bind:this={allStars}>
    {#each stars as star, i}
        <g transform={randoPosition()} class="star">
            <TwinklingStar />
        </g>
    {/each}
</g>
